import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllPackage, deleteTourPackage } from '../redux/slices/packageSlice';
import { useNavigate } from 'react-router-dom';
import AdminSidebar from '../Components/AdminSidebar';
import AdminPackageCard from '../Components/Cards/AdminPackagesCard';

const AllPackage = () => {
    const [activeSection, setActiveSection] = useState('all-package');
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { allPackage, loading, error } = useSelector((state) => state.package);

    useEffect(() => {
        dispatch(fetchAllPackage());
    }, [dispatch]);

    const handleEdit = (pkg) => {
        navigate(`/edit-package/${pkg._id}`);
    };

    const handleDelete = (id) => {
        dispatch(deleteTourPackage(id));
    };

    const tourTypes = ['Domestic', 'International', 'Short', 'Customised', 'Activities'];

    // Group packages by tourType
    const groupedPackages = tourTypes.reduce((acc, type) => {
        acc[type] = allPackage.filter((pkg) => pkg.tourType === type);
        return acc;
    }, {});

    if (error) return <div className="text-center text-red-500 py-10">Error: {error}</div>;

    return (
        <div className="min-h-screen flex bg-gray-50">
            {/* Fixed Sidebar */}
            <div className="fixed top-0 left-0 h-full w-64 z-10 bg-white shadow-md">
                <AdminSidebar setActiveSection={setActiveSection} activeSection={activeSection} />
            </div>

            {/* Main Content */}
            <div className="ml-72 flex-1 px-6 py-8 overflow-y-auto">
                <h2 className="text-2xl font-bold text-custom-blue mb-6">All Packages</h2>

                {loading ? (
                    <p className="text-center text-gray-500">Loading packages...</p>
                ) : allPackage.length === 0 ? (
                    <p className="text-center text-gray-500">No packages available.</p>
                ) : (
                    <div className="space-y-8">
                        {tourTypes.map((type) => (
                            <div key={type} className="mb-8">
                                <h3 className="text-xl font-semibold text-gray-800 mb-4">{`${type} Tours`}</h3>
                                {groupedPackages[type].length === 0 ? (
                                    <p className="text-gray-500">No {type.toLowerCase()} packages available.</p>
                                ) : (
                                    <div
                                        className="flex overflow-x-auto overflow-y-hidden gap-6 pb-4 snap-x snap-mandatory scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100"
                                        style={{ overscrollBehaviorX: 'contain' }}
                                    >
                                        {groupedPackages[type].map((pkg) => (
                                            <div key={pkg._id} className="flex-none w-[270px] snap-start">
                                                <AdminPackageCard
                                                    pkg={pkg}
                                                    onEdit={handleEdit}
                                                    onDelete={handleDelete}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AllPackage;